import { create } from 'zustand';
import { authClient, type AuthUser } from '../auth/client';

export type AuthStatus = 'unknown' | 'guest' | 'authenticated' | 'offline';

interface AuthState {
  status: AuthStatus;
  user: AuthUser | null;
  checkSession: () => Promise<void>;
  login: (
    email: string,
    password: string,
  ) => Promise<{ ok: true } | { ok: false; offline: boolean; message: string }>;
  register: (
    name: string,
    email: string,
    password: string,
  ) => Promise<{ ok: true } | { ok: false; offline: boolean; message: string }>;
  logout: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  status: 'unknown',
  user: null,

  async checkSession() {
    const result = await authClient.getSession();
    if (result.kind === 'offline') {
      set({ status: 'offline', user: null });
    } else if (result.kind === 'authenticated') {
      set({ status: 'authenticated', user: result.user });
    } else {
      set({ status: 'guest', user: null });
    }
  },

  async login(email, password) {
    const result = await authClient.login(email, password);
    if (result.ok) {
      set({ status: 'authenticated', user: result.user });
      return { ok: true };
    }
    return result;
  },

  async register(name, email, password) {
    const result = await authClient.register(name, email, password);
    if (result.ok) {
      set({ status: 'authenticated', user: result.user });
      return { ok: true };
    }
    return result;
  },

  async logout() {
    await authClient.logout();
    set({ status: 'guest', user: null });
  },
}));
